/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck
import Link from 'next/link';
import {Fragment} from 'react'
import { Menu, Transition } from '@headlessui/react';
import {MenuOption, DynamicKeySchema} from '@vc-workspace/utils-schemas';
import {ArrowDropDown, Check} from '@mui/icons-material';
import styles from './utils-menu-dropdown.module.css';
import { Typography } from '@vc-workspace/utils-typography';

/* eslint-disable-next-line */
export interface UtilsMenuDropdownProps {
  placeholderText: string,
  whiteTheme?: boolean,
  menuOptions: MenuOption[],
  selectionPrefix?: string,
  queryKey: string,
  query?: DynamicKeySchema,
  basePath: string
}

export function UtilsMenuDropdown(props: UtilsMenuDropdownProps) {

  if(!props.menuOptions || !props.menuOptions.length) {
    return null;
  }

  function MenuItemLink(props: any) {
    const { href, children, ...rest } = props
    return (
      <Link href={href}>
        <a {...rest}>{children}</a>
      </Link>
    )
  }

  return (
    <Menu as="div" className="relative inline-block text-left">
      {({open}) => (
        <>
          <div>
            <Menu.Button className={`${props.whiteTheme ? styles.menuCtaWhite : styles.menuCta} text-sm ${open ? `shadow-lg ${styles.menuCtaOpen}` : ''}`}>
              <Typography type="Body1" color="nero" className='pr-2' semi_bold inline>
                Sort By:
              </Typography>
              <Typography type="Body1" color="nero" className={styles.menuUnderline} inline>
                {props.placeholderText} <ArrowDropDown />
              </Typography>
            </Menu.Button>
          </div>
          <Transition
            as={Fragment}
            enter="transition ease-out duration-100"
            enterFrom="transform opacity-0 scale-95"
            enterTo="transform opacity-100 scale-100"
            leave="transition ease-in duration-75"
            leaveFrom="transform opacity-100 scale-100"
            leaveTo="transform opacity-0 scale-95"
          >
            <Menu.Items className={`${styles.menuContainer} absolute right-0 w-56 mt-2 origin-top-right overflow-hidden bg-white divide-y divide-gray-100 rounded-md shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none`}>
              {
                props.menuOptions.map(item => (
                  <Menu.Item>
                    {({ active }) => (
                      <MenuItemLink
                        href={{
                          pathname: props.basePath,
                          query: {
                            ...props.query,
                            ...item.query
                          }
                        }}
                        className={`
                          
                          ${item.active ? `${styles.menuSelected}` : ''} 
                          ${styles.menuItem} 
                          filter-item-bg group flex items-center w-full px-2 py-2 text-sm text-gray-900`}
                      >
                        {item.label} {item.active ? <Check fontSize="small" className={`${styles.menuSelectedIcon}`} /> : null}
                      </MenuItemLink>
                    )}
                  </Menu.Item>
                ))
              }
            </Menu.Items>
          </Transition>
        </>
      )}
      
    </Menu>
  );
}
